import profileFooterBG from '../assets/home/profileFooterBG.png'

const dataProfileFooter = {
    image: profileFooterBG,
}

export default dataProfileFooter;